module.exports = __webpack_public_path__ + "67344ccdc97f9b0481eec96b5df22273.jpg";